"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/function-component-definition */
const react_1 = __importStar(require("react"));
const Image_1 = require("~/components/UI/Image");
const RadioButton_1 = __importDefault(require("~/components/common/controls/RadioButton"));
const assets_1 = require("~/assets");
const utils_1 = require("~/utils/utils");
const CurrentFastenersGroup_scss_1 = __importDefault(require("./CurrentFastenersGroup.scss"));
const CurrentFastenersGroup = ({ group, selected, onSelect }) => {
    var _a, _b;
    const [opened, setOpened] = (0, react_1.useState)(false);
    const toggleGroupOpened = () => setOpened((current) => !current);
    const handleSelect = (item) => onSelect(item);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: CurrentFastenersGroup_scss_1.default.group },
            react_1.default.createElement("img", { className: `${CurrentFastenersGroup_scss_1.default.open} ${CurrentFastenersGroup_scss_1.default.image}`, onClick: toggleGroupOpened, src: opened ? assets_1.svgSystemChevronDown : assets_1.svgSystemChevronRight }),
            react_1.default.createElement(Image_1.Image, { className: CurrentFastenersGroup_scss_1.default.image, src: (0, utils_1.formatAssetsURL)((_b = (_a = group === null || group === void 0 ? void 0 : group.items[0]) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.url) }),
            react_1.default.createElement("div", null, group.name)),
        opened
            ? group.items.map((fastener) => {
                var _a;
                return (react_1.default.createElement("div", { className: CurrentFastenersGroup_scss_1.default.fastener, key: fastener.id },
                    react_1.default.createElement("div", { className: CurrentFastenersGroup_scss_1.default.image }),
                    react_1.default.createElement(RadioButton_1.default, { onSelect: () => handleSelect(fastener), selected: (selected === null || selected === void 0 ? void 0 : selected.id) === fastener.id },
                        react_1.default.createElement(Image_1.Image, { className: CurrentFastenersGroup_scss_1.default.image, src: (0, utils_1.formatAssetsURL)((_a = fastener.image) === null || _a === void 0 ? void 0 : _a.url) }),
                        react_1.default.createElement("div", { className: CurrentFastenersGroup_scss_1.default.itemNumber }, `#${fastener.item_number}`),
                        react_1.default.createElement("div", { className: CurrentFastenersGroup_scss_1.default.description }, fastener.description))));
            })
            : null));
};
exports.default = CurrentFastenersGroup;
